var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.272 23.8h20.99c1.026 0 1.871-.835 1.871-1.849v-6.588a.602.602 0 00-.604-.596.602.602 0 00-.604.596v6.588a.666.666 0 01-.664.656H3.272a.666.666 0 01-.664-.656V9.19c0-.358.302-.656.664-.656l6.679-.03a.602.602 0 00.604-.596.602.602 0 00-.604-.597H3.272c-1.027 0-1.872.835-1.872 1.85v12.76c0 1.044.845 1.879 1.872 1.879z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.869 15.65c-.062.373.092.746.43.901a.81.81 0 00.368.093.815.815 0 00.615-.28c2.304-2.703 6.85-2.796 8.447-2.734v2.113c0 .31.184.59.46.746a.799.799 0 00.861-.124l6.543-5.533a.879.879 0 00.307-.652.815.815 0 00-.307-.622l-6.604-5.19a.857.857 0 00-.86-.093c-.277.124-.461.435-.461.746v2.206c-7.588 1.554-9.4 6.403-9.8 8.423zm10.413-7.273c.369-.062.645-.404.645-.808V5.891l5.468 4.32-5.468 4.569v-1.617a.813.813 0 00-.768-.808c-.215 0-.553-.03-1.013-.03-1.782 0-5.192.279-7.65 2.082.922-2.083 3.134-4.973 8.786-6.03z"
  }))));
}

export default SvgShare;